import './style.scss';
import 'swiper/swiper.scss';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import {initArchiveFilterSearch} from "../../scripts/archive-filter-search";

export function footerBlock() {
    const footerSelector = document.querySelector('footer');
    if (footerSelector) {
        const form = footerSelector.querySelector('.nl');
        if (form) {
            const input = form.querySelector('.nl__input');
            const cta = form.querySelector('.nl__cta');
            const step = form.querySelector('.nl__step');
            const successEl = form.querySelector('.nl__success');
            
            const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
            
            cta.classList.add('disabled');
            
            input.addEventListener('input', () => {
                if (input.value.trim().length > 0) {
                    cta.classList.remove('disabled');
                    form.classList.remove('error');
                } else {
                    cta.classList.add('disabled');
                }
            });
            
            const goName = () => {
                form.dataset.state = 'name';
                input.type = 'text';
                input.value = '';
                input.placeholder = 'First Name';
                step.textContent = '2 / 2';
                cta.textContent = 'Submit';
                cta.classList.add('nl__cta--ghost');
                cta.dataset.action = 'submit';
                cta.classList.add('disabled');
                input.focus();
            };
            
            const goSuccess = () => {
                form.classList.remove('error');
                
                if (successEl) {
                    successEl.classList.add('active');
                }
            };
            
            const pokeError = () => {
                form.classList.add('error');
            };
            
            const validate = () => {
                const st = form.dataset.state || 'email';
                if (st === 'email') {
                    const ok = EMAIL_RE.test((input.value || '').trim());
                    if (!ok) {
                        pokeError();
                        return false;
                    }
                    return true;
                } else {
                    const ok = (input.value || '').trim().length >= 2;
                    if (!ok) {
                        pokeError();
                        return false;
                    }
                    return true;
                }
            };
            
            cta.addEventListener('click', () => {
                if (cta.classList.contains('disabled')) return;
                
                const action = cta.dataset.action;
                if (action === 'next') {
                    if (!validate()) return;
                    goName();
                } else {
                    if (!validate()) return;
                    cta.setAttribute('aria-disabled', 'true');
                    cta.textContent = 'Sending...';
                    setTimeout(() => {
                        goSuccess();
                    }, 600);
                }
            });
            
            form.addEventListener('input', () => {
                if (form.dataset.state === 'name') {
                    if (input.value.trim().length > 0) {
                        cta.classList.remove('disabled');
                    } else {
                        cta.classList.add('disabled');
                    }
                }
            });
        }
    }
    
    // General Cards Swiper
    const sectionsWithSwiper = [...document.querySelectorAll('section')]
        .filter((sec) => sec.querySelector('.cards-swiper') && !sec.classList.contains('inner_block'));
    
    for (const sec of sectionsWithSwiper) {
        const swiperEl = sec.querySelector('.cards-swiper');
        const controllerEl = sec.querySelector('.controller-bar');
        
        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
        if (slideCount <= 3 && controllerEl) {
            controllerEl.style.display = 'none';
        }
        
        new Swiper(swiperEl, {
            slidesPerView: 1.27,
            spaceBetween: 0,
            speed: 500,
            breakpoints: {
                768: { slidesPerView: 2 },
                992: { slidesPerView: 2 },
                1280: { slidesPerView: 3 },
            },
            observer: true,
            observeParents: true,
            modules: [Navigation],
            navigation: {
                nextEl: sec.querySelector('.swiper-button-next'),
                prevEl: sec.querySelector('.swiper-button-prev'),
            },
        });
    }
    
    
}
